import { debounce } from "lodash";
import { urlService } from "./urlService";

const debouncedGetResult = debounce(
  (
    getResult,
    pageNumber,
    setCurrentPage,
    hideQueryParams,
    searchText
  ) => {
    if (!hideQueryParams) {
      if (searchText.trim()) {
        urlService.setQueryStringValue("search", searchText.replace(/\+/g, "%2B"));
      } else {
        urlService.removeParam("search");
      }
      urlService.setQueryStringValue("page", pageNumber);
    }
    getResult();
    setCurrentPage(pageNumber);
  },
  1000
);

const handleSearchWithDebouncing = ({
  searchText,
  prevSearchText,
  setSearchText,
  getResult,
  setCurrentPage,
  hideQueryParams = false
}) => {
  setSearchText(searchText);
  if (
    searchText.trim() !== "" ||
    (searchText === "" && prevSearchText.trim() !== "")
  ) {
    debouncedGetResult(
      getResult,
      1,
      setCurrentPage,
      hideQueryParams,
      searchText
    );
  }
};

export const setSearchParams=(searchText)=>{
    if (searchText.trim()) {
      urlService.setQueryStringValue("search", searchText.replace(/\+/g, "%2B"));
    } else {
      urlService.removeParam("search");
    }
  }



export default handleSearchWithDebouncing;
